<template src="./Location.html">
</template>

<script>
import {
  getLocations,
  putLocation,
  postLocation
} from '@/services/location'
const model = { name: '', id: null }

export default {
  name: 'Location',
  data () {
    return {
      locations: [],
      locationModel: model,
      isEditing: false
    }
  },

  mounted () {
    this.loadLocations()
  },

  methods: {
    handleSaveLocation () {
      const httpSave = this.isEditing ? putLocation : postLocation
      httpSave(this.locationModel)
        .then((res) => {
          this.$notify.success({
            message: 'Location Saved'
          })
          if (!this.isEditing) {
            this.locations.push(res.data)
          }
          this.locationModel = model
          this.isEditing = false
        })
        .catch(() => {
          this.$notify.error({
            message: 'Error saving location'
          })
        })
    },
    loadLocations () {
      getLocations().then(res => {
        this.locations = res.data
      })
    },
    editLocation (item) {
      this.locationModel = item
      this.isEditing = true
    }
  }
}
</script>

<style src="./location.scss" lang="scss"  scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/location/Location.vue